import { render, staticRenderFns } from "./UkrposhtaEditingPage.vue?vue&type=template&id=9b2d5a66"
import script from "./UkrposhtaEditingPage.vue?vue&type=script&lang=js"
export * from "./UkrposhtaEditingPage.vue?vue&type=script&lang=js"
import style0 from "./UkrposhtaEditingPage.vue?vue&type=style&index=0&id=9b2d5a66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports